import { sheetV1 } from '@otto-ec/otto-components/sheet';
import { createImageUrl } from '../../../_common/server/tools/create-image-url';
import { trackEvent } from '@otto-ec/nexus-registry/pdp/tracking';

type SheetContext = {
    sheetElement: HTMLOcSheetV1Element;
    contentElement: HTMLElement;
    buttonElement: HTMLOcButtonV1Element;
};

export async function openViewInMyRoomSheet() {
    const { contentElement, slotElement, buttonElement } = createBasicSheetElements();

    const sheetElement = await sheetV1.create({
        id: 'pdp_view-in-my-room-button__sheet',
        headline: 'In meinem Raum ansehen',
    });

    const ctx: SheetContext = { sheetElement, contentElement, buttonElement };

    sheetElement.replaceChildren(contentElement, slotElement);
    showIntroStep(ctx);
    sheetElement.open = true;

    trackEvent({
        product_InteriorDesignConsultant: ['Open'],
    });
}

function createBasicSheetElements() {
    const contentElement = document.createElement('div');
    const buttonElement = document.createElement('oc-button-v1');

    const slotElement = document.createElement('div');
    slotElement.slot = 'actions';
    slotElement.appendChild(buttonElement);

    return { contentElement, slotElement, buttonElement };
}

function showIntroStep(ctx: SheetContext) {
    const figureElement = createFigureElement(
        'illustration_augmented-reality',
        'Einfach ein Foto deines Raumes hochladen,<br>um Möbel direkt bei dir Zuhause zu erleben.'
    );

    ctx.contentElement.replaceChildren(figureElement);
    ctx.buttonElement.iconTypeLeft = 'camera';
    ctx.buttonElement.innerHTML = 'Foto hochladen';
    ctx.buttonElement.addEventListener('click', () => showConsentStep(ctx), { once: true });
}

function showConsentStep(ctx: SheetContext) {
    ctx.buttonElement.disabled = true;
    ctx.buttonElement.textContent = 'Foto hochladen';
    ctx.buttonElement.iconTypeLeft = 'camera';
    ctx.buttonElement.addEventListener('click', () => showUploadStep(ctx), { once: true });

    const textElement = document.createElement('div');
    textElement.textContent = `Die dargestellten Bilder werden mithilfe künstlicher Intelligenz generiert und dienen
        ausschließlich der visuellen Veranschaulichung. Aussehen, Raumaufteilung, Materialien, Lichtverhältnisse
        sowie dargestellte Details können von der tatsächlichen Ausführung abweichen. Eventuell enthaltene
        persönliche oder dekorative Elemente entsprechen nicht zwingend der Realität.`;

    const inputElement = document.createElement('input');
    inputElement.type = 'checkbox';
    inputElement.addEventListener('change', () => {
        ctx.buttonElement.disabled = !inputElement.checked;
    });

    const labelElement = document.createElement('label');
    labelElement.className = 'pdp_view-in-my-room-button__checkbox-label';
    labelElement.slot = 'label';
    labelElement.innerHTML = `Ich akzeptiere die Servicebedingungen und bestätige, dass ich die Datenschutz- und
        Cookie-Richtlinien verstanden habe.`;

    const checkboxElement = document.createElement('oc-checkbox-v2');
    checkboxElement.className = 'pdp_view-in-my-room-button__checkbox';
    checkboxElement.append(inputElement, labelElement);

    ctx.contentElement.replaceChildren(textElement, checkboxElement);

    trackEvent({
        product_InteriorDesignConsultant: ['Photo Upload Step 1'],
    });
}

function showUploadStep(ctx: SheetContext) {
    ctx.sheetElement.headline = 'Diese Funktion ist bald verfügbar';

    ctx.buttonElement.textContent = 'Schließen';
    ctx.buttonElement.iconTypeLeft = undefined;
    ctx.buttonElement.addEventListener('click', () => ctx.sheetElement.close(), { once: true });

    const figureElement = createFigureElement(
        'illustration_web-renovation',
        '<h3 class="oc-headline-50 oc-mb-50">Danke für dein Interesse!</h3><p class="oc-mb-0">An dieser innovativen Funktion, mit der du Möbel hautnah in deinen eigenen vier Wänden ansehen kannst, arbeiten wir noch.</p>'
    );

    ctx.contentElement.replaceChildren(figureElement);

    trackEvent({
        product_InteriorDesignConsultant: ['Photo Upload Step 2'],
    });
}

function createFigureElement(imageId: string, figcaption: string) {
    const imgElement = document.createElement('img');
    imgElement.className = 'pdp_view-in-my-room-button__img';
    imgElement.src = createImageUrl(imageId, 'h=768&sm=clamp&fmt=auto&qlt=40&unsharp=0,1,0.6,7');

    const figcaptionElement = document.createElement('figcaption');
    figcaptionElement.className = 'pdp_view-in-my-room-button__figcaption';
    figcaptionElement.innerHTML = figcaption;

    const figureElement = document.createElement('figure');
    figureElement.className = 'pdp_view-in-my-room-button__figure';
    figureElement.append(imgElement, figcaptionElement);

    return figureElement;
}
